import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	
	Typography,
	Divider,
} from "@mui/material";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import Grid2 from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
	drawingsButton: {
		backgroundColor: "rgba(147, 112, 219, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(147, 112, 219, 0.2)",
		},
	},
	attachmentsButton: {
		backgroundColor: "rgba(255, 165, 0, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(255, 165, 0, 0.4)",
		},
	},
	lotoButton: {
		backgroundColor: "rgba(50, 205, 50, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(50, 205, 50, 0.2)",
		},
	},
	partsButton: {
		backgroundColor: "rgba(70, 130, 180, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(70, 130, 180, 0.2)",
		},
	},
}));

interface Props {
	open: boolean;
	onClose: () => void;
	onOpenAssetAttachmentsPicker: () => void;
}

export const ImportAssetResourcesDialog = ({
	open,
	onClose,
	onOpenAssetAttachmentsPicker,
}: Props) => {
	const classes = useStyles();

	const {
		state: { assetAttachments },
	} = useWorkOrderModalsContext();

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle style={{ paddingBottom: 5 }}>
				<Typography variant="h5">Import Asset Resources</Typography>
			</DialogTitle>
			<Divider />

			<DialogContent>
				<Typography style={{ paddingBottom: 5 }}>
					The asset to which this work order is assigned has attachments
					available. <br />
					You can review and assign them to the work order:
				</Typography>
				<Grid2 spacing={2} style={{ padding: "10px 0" }}>
					<Grid2 size={{ xs: 12 }}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.attachmentsButton}`}
							onClick={onOpenAssetAttachmentsPicker}
							disabled={assetAttachments.length === 0}>
							Import Attachments ({assetAttachments.length})
						</Button>
					</Grid2>
				</Grid2>
			</DialogContent>
			<Divider />
			<DialogActions
				sx={{
					padding: "0px 24px",
					marginTop: "16px",
					paddingBottom: "16px",
					justifyContent: "center",
				}}>
				<Grid2 container>
					<Grid2 size={{ xs: 12, md: 12 }}>
						<Button
							fullWidth
							variant="contained"
							color="inherit"
							onClick={onClose}>
							CLOSE
						</Button>
					</Grid2>
				</Grid2>
			</DialogActions>
		</Dialog>
	);
};
